export default __webpack_public_path__ + "static/media/image1.b299b6de.jpg";